var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"rounded-lg w-full object-cover",attrs:{"src":_vm.imgSrc,"alt":""},on:{"load":function($event){_vm.imgSrc = _vm.src}}})
}
var staticRenderFns = []

export { render, staticRenderFns }